// extracted by mini-css-extract-plugin
export var alignRightItem = "styles-module--alignRightItem--3U8DH";
export var content = "styles-module--content--tBaG0";
export var item = "styles-module--item--nNAuF";
export var itemContainer = "styles-module--itemContainer--7ll0R";
export var section = "styles-module--section--MqSpZ";
export var textContainer = "styles-module--textContainer--yEMhS";
export var title = "styles-module--title--L4xf+";
export var visibleTextContainer = "styles-module--visibleTextContainer--uwA4s";